import { ReactElement } from 'react';
import ModalImg from 'src/assets/images/create-menu-item-modal.png';
import { Modal } from '@weareopenr/component-library';
import ChannelRuleModalContent from './ChannelRuleModalContent';
import { useExternalSystems } from 'src/hooks/useExternalSystems';
import { getPricingChannels } from 'src/helpers/channels/getPricingChannels';
import { IPriceRule } from 'src/types/price.types';

interface ChannelRuleModalProps {
  closeModal: () => void;
  open: boolean;
  priceSchemeId: string;
  priceRuleToEdit?: IPriceRule;
  step?: number;
  preSelectedChannelId?: string | null;
}

export const ChannelRuleModal = ({
  closeModal,
  open,
  priceSchemeId,
  priceRuleToEdit,
  step,
  preSelectedChannelId,
}: ChannelRuleModalProps): ReactElement => {
  const { data: externalSystems } = useExternalSystems();
  const channels = getPricingChannels(externalSystems);

  return (
    <Modal closeModal={closeModal} open={open} image={ModalImg} imageAlt="Picture of ingredient">
      <ChannelRuleModalContent
        priceRuleToEdit={priceRuleToEdit}
        priceSchemeId={priceSchemeId}
        defaultStep={step}
        preSelectedChannelId={preSelectedChannelId}
        channels={channels}
        closeModal={closeModal}
      />
    </Modal>
  );
};
